import { showSnackbar } from "@sembark-travel/ui-snackbar"
import { useXHR } from "@sembark-travel/xhr"
import { useEffect, useState } from "react"

export function useDebounce<T>(value: T, delay = 500): T {
	const [debounced, setDebounced] = useState(value)
	useEffect(() => {
		const t = setTimeout(() => setDebounced(value), delay)
		return () => clearTimeout(t)
	}, [value, delay])
	return debounced
}

export type EntityId = string | number

/** true when the selected primary is no longer part of the duplicates list */
export function isPrimaryRemoved<T>(
	primary: T,
	duplicates: T[],
	getId: (item: T) => EntityId
) {
	return !duplicates.some((d) => getId(d) === getId(primary))
}

export type MergeFormValues<T> = {
	q: string
	primary: T
	duplicates: T[]
}

export function useMergeEntities<T>({
	mergeUrl,
	getId,
	onSuccess,
}: {
	mergeUrl: string
	getId: (item: T) => EntityId
	onSuccess: (primary: T) => void
}) {
	const xhr = useXHR()
	// changing this key remounts the form ("merge more")
	const [resetKey, setResetKey] = useState(0)

	async function merge(
		primary: T,
		duplicates: T[],
		confirm: () => Promise<boolean>,
		entityLabel: string
	) {
		if (!(await confirm())) return
		const { message } = await xhr
			.post<{ message: string }>(mergeUrl, {
				primary: getId(primary),
				duplicates: duplicates.map(getId),
			})
			.then((resp) => resp.data)
		showSnackbar(message)
		if (
			window.confirm(`Do you want to merge more duplicate ${entityLabel}s ?`)
		) {
			setResetKey((k) => k + 1)
		} else {
			onSuccess(primary)
		}
	}

	return { resetKey, merge }
}
